import { collateralClient } from "api";

const collateralService = {};

function buildQuery(params) {
    return Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null) // Filter out undefined or null values
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
}

collateralService.getDocReceiveList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex = userInputIndex === 0 ? 0 : userInput.pageIndex - 1;

  const params = {
      pageIndex: decrementIndex,
      pageSize: userInput.pageSize,
      BranchId: userInput?.branchId,
      CustomerName: userInput?.customerName,
      LoanNo: userInput?.loanNo,  
      AssetDocStatus: userInput?.assetDocStatus,
      OwnerName: userInput?.ownerName,
  }

    return collateralClient({
      url: `/ApkLoanAsset/document_receipt_request_list?${buildQuery(params)}`,
      method: "get",
    });
};

collateralService.getDocReceiveDetail = function (loanId) {
  console.log("loanId in service", loanId);
  return collateralClient({
    url: `/ApkLoanAsset/detail/${loanId}`,
    method: "get",
  });
};

collateralService.getCabinetList = function () {
  return collateralClient({
    url: `/Cabinet/list`,
    method: "get",
  });          
};

collateralService.getCabinetBoxList = function () {
  return collateralClient({
    url: `/CabinetBox/list`,
    method: "get",
  });          
};

collateralService.saveLoanAsset = function (payload) {
  return collateralClient({
    url: `/DocumentReceipt/save`,
    method: "post",
    data: payload
  });          
};

collateralService.getDetailEdit = function (docrcvTransactionId) {
  return collateralClient({
    url: `/DocumentReceipt/approvalDetail/${docrcvTransactionId}`,
    method: "get",
  });
};

collateralService.putRequestApproval = function (listRequest) {
  return collateralClient({
    url: `/DocumentReceipt/request`,
    method: "put",
    data: listRequest,
  });
};


collateralService.getRecApprovalList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex = userInputIndex === 0 ? 0 : userInput.pageIndex - 1;

  const params = {
      pageIndex: decrementIndex,
      pageSize: userInput.pageSize,
      BranchId: userInput?.branchId,
      CustomerName: userInput?.customerName,
      LoanNo: userInput?.loanNo,  
      AssetDocStatus: userInput?.assetDocStatus,
      OwnerName: userInput?.ownerName,
  }
  return collateralClient({
    url: `/ApkLoanAsset/document_receipt_approval_list?${buildQuery(params)}`,
    method: "get",
  });
};

collateralService.putApprovedDocRcv = function (listApproval) {
  return collateralClient({
    url: `/DocumentReceipt/approve`,
    method: "put",
    data: listApproval,
  });
};

collateralService.putReturnDocRcv = function (listApproval) {
  return collateralClient({
    url: `/DocumentReceipt/return`,
    method: "put",
    data: listApproval,
  });
};

collateralService.getRecIssueList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex = userInputIndex === 0 ? 0 : userInput.pageIndex - 1;

  const params = {
      pageIndex: decrementIndex,
      pageSize: userInput.pageSize,
      BranchId: userInput?.branchId,
      CustomerName: userInput?.customerName,
      LoanNo: userInput?.loanNo,  
      AssetDocStatus: userInput?.assetDocStatus,
      OwnerName: userInput?.ownerName,
  }
  return collateralClient({
    url: `/ApkLoanAsset/document_issuance_request_list?${buildQuery(params)}`,
    method: "get",
  });
};

collateralService.getApprovalIssueList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex = userInputIndex === 0 ? 0 : userInput.pageIndex - 1;

  const params = {
      pageIndex: decrementIndex,
      pageSize: userInput.pageSize,
      BranchId: userInput?.branchId,
      CustomerName: userInput?.customerName,
      LoanNo: userInput?.loanNo,  
      AssetDocStatus: userInput?.assetDocStatus,
      OwnerName: userInput?.ownerName,
  }
  return collateralClient({
    url: `/ApkLoanAsset/document_issuance_approval_list?${buildQuery(params)}`,
    method: "get",
  });
};

collateralService.saveDocIssue = function (payload) {
  return collateralClient({
    url: `/DocumentIssuance/save`,
    method: "post",
    data: payload
  });          
};

collateralService.putReqApprovalIssue = function (listRequest) {
  return collateralClient({
    url: `/DocumentIssuance/request`,
    method: "put",
    data: listRequest,
  });
};


collateralService.putApprovedIssue = function (listApproval) {
  return collateralClient({
    url: `/DocumentIssuance/approve`,
    method: "put",
    data: listApproval,
  });
};


collateralService.putReturnIssue = function (listApproval) {
  return collateralClient({
    url: `/DocumentIssuance/return`,
    method: "put",
    data: listApproval,
  });
};

collateralService.getChangeLocList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex = userInputIndex === 0 ? 0 : userInput.pageIndex - 1;

  const params = {
      pageIndex: decrementIndex,
      pageSize: userInput.pageSize,
      BranchId: userInput?.branchId,
      CustomerName: userInput?.customerName,
      LoanNo: userInput?.loanNo,  
      AssetDocStatus: userInput?.assetDocStatus,
      OwnerName: userInput?.ownerName,
  }
  return collateralClient({
    url: `/ApkLoanAsset/change_location_request_list?${buildQuery(params)}`,
    method: "get",
  });
};

collateralService.saveChangeLocDoc = function (payload) {
  return collateralClient({
    url: `/ChangeLocation/save`,
    method: "post",
    data: payload
  });          
};

collateralService.putReqApprovalChangeLoc = function (listApproval) {
  return collateralClient({
    url: `/ChangeLocation/request`,
    method: "put",
    data: listApproval,
  });
};

collateralService.putApprovedChangeLoc = function (listApproval) {
  return collateralClient({
    url: `/ChangeLocation/approve`,
    method: "put",
    data: listApproval,
  });
};

collateralService.putReturnChangeLoc = function (listApproval) {
  return collateralClient({
    url: `/ChangeLocation/return`,
    method: "put",
    data: listApproval,
  });
};

collateralService.getChangeLocApprovalList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex = userInputIndex === 0 ? 0 : userInput.pageIndex - 1;

  const params = {
      pageIndex: decrementIndex,
      pageSize: userInput.pageSize,
      BranchId: userInput?.branchId,
      CustomerName: userInput?.customerName,
      LoanNo: userInput?.loanNo,  
      AssetDocStatus: userInput?.assetDocStatus,
      OwnerName: userInput?.ownerName,
  }
  return collateralClient({
    url: `/ApkLoanAsset/change_location_approval_list?${buildQuery(params)}`,
    method: "get",
  });
};

collateralService.getHistoryLogCollateral = function (loanId) {
  return collateralClient({
    url: `/ApkLoanAsset/detailwithhistory/${loanId}`,
    method: "get",
  });
};

collateralService.getInquiryList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex = userInputIndex === 0 ? 0 : userInput.pageIndex - 1;

  const params = {
      pageIndex: decrementIndex,
      pageSize: userInput.pageSize,
      BranchId: userInput?.branchId,
      CustomerName: userInput?.customerName,
      LoanNo: userInput?.loanNo,  
      AssetDocStatus: userInput?.assetDocStatus,
      OwnerName: userInput?.ownerName,
  }
  return collateralClient({
    url: `/ApkLoanAsset/list?${buildQuery(params)}`,
    method: "get",
  });
};


export default collateralService;